import React, { useEffect, useState } from "react";

import useTableQ from "../../../utils/Hooks/useTableQ";
import request from "../../../utils/request.js";

import styles from "./MaterialsTable.module.css";

import TableContainerQ from "../../../components/TableBionovaQ/TableContainerQ/TableContainerQ";
import TableHeadQ from "../../../components/TableBionovaQ/TableHeadQ/TableHeadQ";
import TableHeaderCellQ from "../../../components/TableBionovaQ/TableHeaderCellQ/TableHeaderCellQ";
import TableBodyQ from "../../../components/TableBionovaQ/TableBodyQ/TableBodyQ";
import TableRowQ from "../../../components/TableBionovaQ/TableRowQ/TableRowQ";
import TableRowCellQ from "../../../components/TableBionovaQ/TableRowCellQ/TableRowCellQ";
import TablePaginationQ from "../../../components/TableBionovaQ/TablePaginationQ/TablePaginationQ.jsx";
import TruncatedText from "../../../components/TableBionovaQ/TruncatedText/TruncatedText.jsx";
import SpinnerQ from "../../../components/SpinnerQ/SpinnerQ.jsx";

import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { CiImageOn } from "react-icons/ci";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ.jsx";
import t from "../../../utils/translation.js";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ.jsx";
import ImageDrop from "../../../components/ImageDrop/ImageDrop.jsx";
import ButtonQ from "../../../components/ButtonQ/ButtonQ.js";
import { FcAddImage } from "react-icons/fc";
import { FcEditImage } from "react-icons/fc";

const MaterialsTable = ({
  onPageChange,
  onItemsPerPageChange,
  getMaterials,
  handleData,
  handleModal,
  handleDetail,
  materials,
  loading,
  totalPages,
}) => {
  // const [loading, setLoading] = useState(true);

  const [modalImage, setModalImage] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [material, setMaterial] = useState({});
  // const getMaterialList = async () => {
  //   setLoading(true);
  //   try {
  //     let res = await request().get(`/api/material/list?includeCount=true&pageSize=${itemsPerPage}&page=${currentPage}`);

  //     setMaterials(res.data.materialListatorList);
  //     setTotalPages(res.data.totalPages);
  //     setLoading(false);
  //   } catch (e) {
  //     toast.error(e.response?.data?.messagge);
  //   }
  // };

  const {
    currentPage,
    currentItems,
    itemsPerPage,
    handleChangePage,
    handleChangeItemsPerPage,
    handleSortByColumn,
    setCurrentPage,
  } = useTableQ(
    materials,
    [
      "materialName",
      "materialTypeName",
      "methodName",
      "isImplant",
      "isEndoscope",
      "materialSerial",
      "cyclesWarning",
      "observations",
    ],
    totalPages
  );

  const onEdit = (value) => {
    let item = materials.find((m) => m.materialId === value);

    const {
      materialName,
      materialTypeId,
      materialSerial,
      isImplant,
      isEndoscope,
      isSerialized,
      compatibleMethodId,
      observations,
      cyclesWarning,
      materialId,
    } = item;

    handleData({
      name: materialName,
      materialTypeId,
      materialSerial,
      isSerialized: isSerialized,
      isImplant: isImplant,
      isEndoscope: isEndoscope,
      methodId: compatibleMethodId,
      observations,
      cyclesWarning,
      id: materialId,
    });

    handleModal(true);
  };

  const onDelete = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
    }).then((result) => {
      if (result.isConfirmed) {
        request()
          .delete("/api/Material", { id: data })
          .then(() => {
            let newData = materials.filter((material) => material.id !== data);
            getMaterials(newData);
            toast.success("Your material has been deleted.");
          });
      }
    });
  };

  const handleModalImage = (material = {}) => {
    setModalImage((prev) => !prev);
    setMaterial(material);
  };

  const onFileChange = (image) => {
    setMaterial((prev) => ({ ...prev, materialImage: image }));
  };

  const addImage = async (e) => {
    e.preventDefault();
    if (!material.materialImage?.base64Image) {
      return;
    }
    setLoadingModal(true);
    try {
      await request().put("/api/material/upload", {
        materialId: material.materialId,
        imageData: material.materialImage.base64Image,
        imageFormat: material.materialImage.fileFormat,
      });
      handleModalImage();
      getMaterials();
    } catch (error) {
    } finally {
      setLoadingModal(false);
    }
  };

  //  useEffect(() => {
  //   getMaterials(currentPage, itemsPerPage)
  //   }, [currentPage, itemsPerPage]);

  // useEffect(() => {
  //   onPageChange(currentPage);
  // }, [currentPage, onPageChange]);

  // useEffect(() => {
  //   onItemsPerPageChange(itemsPerPage);
  // }, [itemsPerPage, onItemsPerPageChange]);

  useEffect(() => {
    onPageChange(currentPage);
    onItemsPerPageChange(itemsPerPage);
  }, [currentPage, onPageChange, itemsPerPage, onItemsPerPageChange]);

  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <TableContainerQ>
          <TableHeadQ actions={true}>
            <TableHeaderCellQ
              date={true}
              handleClick={() => handleSortByColumn("materialName")}
            >
              {t("NameSpan") || "Name"}
            </TableHeaderCellQ>
            <TableHeaderCellQ
              date={true}
              handleClick={() => handleSortByColumn("materialType")}
            >
              {t("BlankEntry92") || "Material Type"}
            </TableHeaderCellQ>
            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("compatibleMethod")}
            >
              {t("BlankEntry98") || "Suggested Method"}
            </TableHeaderCellQ>
            <TableHeaderCellQ handleClick={() => handleSortByColumn("implant")}>
              {t("BlankEntry93") || "Is Implant"}
            </TableHeaderCellQ>
            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("endoscope")}
            >
              {t("BlankEntry94") || "Is Endoscope/Cannulated"}
            </TableHeaderCellQ>
            <TableHeaderCellQ handleClick={() => handleSortByColumn("serial")}>
              {t("SerialSpan") || "Serial"}
            </TableHeaderCellQ>
            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("cyclesWarning")}
            >
              {t("BlankEntry95") || "Cycles Warning"}
            </TableHeaderCellQ>
            <TableHeaderCellQ
              handleClick={() => handleSortByColumn("observations")}
            >
              {t("ObservationSpan") || "Observation"}
            </TableHeaderCellQ>
            <TableHeaderCellQ>{t("ImageSpan") || "Image"}</TableHeaderCellQ>
          </TableHeadQ>
          {loading ? (
            <div className="spinnerContainer">
              <SpinnerQ />
            </div>
          ) : (
            <TableBodyQ loading={loading}>
              {currentItems.map((m) => (
                <TableRowQ
                  key={m.materialId}
                  actions={true}
                  edit={true}
                  detail={true}
                  deleteRow={true}
                  onEdit={() => onEdit(m.materialId)}
                  onDelete={() => onDelete(m.materialId)}
                  doubleClick={() => onEdit(m.materialId)}
                  onDetail={() => handleDetail(m)}
                >
                  <TableRowCellQ date={true}>
                    <TruncatedText text={m.materialName} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ date={true}>
                    <TruncatedText text={m.materialTypeName} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <TruncatedText text={m.methodName} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <CheckBoxQ checked={m.isImplant} disabled={true} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <CheckBoxQ checked={m.isEndoscope} disabled={true} />
                  </TableRowCellQ>

                  <TableRowCellQ>
                    <TruncatedText text={m.materialSerial} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <TruncatedText text={m.cyclesWarning} maxLength={25} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <TruncatedText text={m.observations} maxLength={15} />
                  </TableRowCellQ>
                  <TableRowCellQ>
                    <div
                      className={styles.imageButton}
                      onClick={() => handleModalImage(m)}
                    >
                      {m.materialImageLink === null ? (
                        <FcAddImage />
                      ) : (
                        <FcEditImage />
                      )}
                    </div>
                  </TableRowCellQ>
                </TableRowQ>
              ))}
            </TableBodyQ>
          )}

          {modalImage && (
            <ModalQ
              open={modalImage}
              title={t("BlankEntry91") || "Material Image"}
              handleClose={handleModalImage}
            >
              {loadingModal ? (
                <div className="spinnerContainer">
                  <SpinnerQ />
                </div>
              ) : (
                <>
                  <ImageDrop
                    defaultValue={{
                      base64Image: material.materialImageLink,
                      imageName: material.materialName,
                      fileFormat: "jpg",
                    }}
                    onFileChange={onFileChange}
                    label={
                      t("DragYourImage") ||
                      "Drag your file here or click to upload"
                    }
                  />
                  <ButtonQ
                    caption={t("Confirm")}
                    disabled={!material.materialImage?.base64Image}
                    onClick={(e) => addImage(e)}
                  >
                    {"Confirm"}
                  </ButtonQ>
                </>
              )}
            </ModalQ>
          )}

          <TablePaginationQ
            handleChangePage={handleChangePage}
            handleChangeItemsPerPage={handleChangeItemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </TableContainerQ>
      </div>
    </div>
  );
};

export default MaterialsTable;
